import kebabCase from 'lodash/kebabCase';
import { DateTime } from 'luxon';

import { platform, isDemoMode } from 'app-components/utils/core';

const clientType = 'Simplifi Web App';
export default function buildUser(authSession, subscriptionTrackingProps, userInfo, businessCounts) {
  // other user keys (could get from profile):
  //   email         profile.username or profile.primaryEmail.address
  //   name
  //   firstName     profile.firstName
  //   lastName      profile.lastName
  const key = authSession && authSession.qcsId;
  const subscriptionPropsLD = {};
  if (subscriptionTrackingProps) {
    Object.keys(subscriptionTrackingProps).forEach((propName) => {
      subscriptionPropsLD[kebabCase(propName)] = subscriptionTrackingProps[propName];
    });
  }

  const ldUser = {
    key: key || 'anon',
    ip: '127.0.0.1', // browsers can't read the local IP; LaunchDarkly has always received the loopback address
    custom: {
      hostname: window?.location?.hostname,
      'browser-name': platform.browser.name,
      'browser-version': platform.browser.version,
      'device-type': platform.browser.type,
      'device-vendor': platform.browser.vendor,
      'device-model': platform.browser.model,

      project: process.env.PROJECT,
      'demo-mode': isDemoMode(),

      'dataset-id': authSession.datasetId,
      'dataset-platform': authSession.datasetPlatform,
      'dataset-created-by-client-id': authSession.datasetCreatedByClientId,
      'dataset-created-at': DateTime.fromISO(authSession.datasetCreatedAt).toMillis(),
      scope: authSession.scope,
      groups: authSession.groups,
      source: userInfo?.source,
      'client-type': clientType,
      'app-version': process.env.APP_VERSION,

      'has-open-business': (businessCounts?.open ?? 0) > 0,
      'has-any-business': (businessCounts?.total ?? 0) > 0,

      ...subscriptionPropsLD,
    },
  };

  return ldUser;
}
